/* eslint-disable require-jsdoc */
/* eslint-disable no-undef */
import {stylers} from './styles/stylers';
import {
  deleteMarkers
} from '../marker/getMarkerData';
import {getDistance} from '../../utils/distance';

/**
 * Location Map
 * Main map rendering function that uses our GMaps API class
 * @param {string} el - Google Map selector
 */

/**
 * Render Map
 * @param {map obj} mapEl - Google Map
 * @param {obj} data - map data
 */

function renderMap(aMap, mapEl) {
  const options = {
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    styles: stylers.styles,
    zoom: aMap.zoom,
    center: aMap.loc,
    mapTypeControl: false,
    streetViewControl: false,
  };
  window.aMapRef = aMap;
  aMap.map = new google.maps.Map(mapEl, options);

  let prevCenter = aMap.map.getCenter();
  if (window.powersearchUserSettings.mapOpts.logoOpts.show) {
    let logoControlDiv = document.createElement('DIV');
    logoControlDiv.classList.add("hearby-map-logo");
    let logoControl = new MyLogoControl(logoControlDiv);
    logoControlDiv.index = 0; // used for ordering
    aMap.map.controls[google.maps.ControlPosition.TOP_LEFT].push(logoControlDiv);
  
    function MyLogoControl(controlDiv) {
      controlDiv.style.padding = '5px';
      let logoText = document.createElement('SPAN');
      logoText.classList.add("hearby-map-logo-text");
      logoText.style.color = 'white';
      logoText.style.fontSize = 'large';
      let logo = document.createElement('IMG');
      logo.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAiCAYAAABFlhkzAAADqUlEQVRIx52WW2hcVRSGv7U9mUx02oi9OElMa0ybaWnshcCMYqEgtPQhiFgQQYvoi/SpCJVCCy0IKVQrQQOC7YP0qVqwqGAb+hDoQ8CxxCaNqZ2Zpo2GJkdi00ZyGSdzzvIhl5rJnJMzs54Oe//7/8/e+99rLcEjfolFw+qyS9HXgFeBBuDp+elHwD2gS5AfxXAjnrKzxXikcCAZixpUd6lyGNgPrC2Gmw8F/gY6RfgckRuJlO16CiSbomGFd1E9DtRTWgwj0iZwPpF+vBv5PzmqRxSOAhHKi0ngtIicWRAxANe31hhUDwYiF/GbjQBHUT14fWuNWRRwHW1WOBbkz6tf2UN4w/O+IgrHXEebAUwyVluhqoeAjUHOYFVLnBdOf8FTzdv9drNRVQ8lY7UVBtfdArT6OGXZEa1qidN45ktWv7zbS0SAVlx3i0HYB9SWcpOayxFau46Gjz8lsqPFC1aLsM+o6t6FuwgaM0ODZD78gH+H/+C5wx/xxOrqYjCjqnsNECvVizo7y9TNXoY/O0VlXT1VjZu9oDEDrC/T88zcvUN26C5iPA9gvQHC5Qrg5Jns+5WZwYwXImyAXLn8ms/z14Xz5B899ILkDDBetoDjkB9/4AcZt4BBX5saQ+jZGqo2NWHCYSrrSsqBgxZCF8ruYg/NVIZZ9+bbRN95n1BdPWJZ4LpMp24F2qAIXUaQK8BYMcQz+1vZcOQ44YZGTCiEGINYFuo4qOuuJDAGcsWI0Adc9UpspurJpYOuy2RvD+701EoCV0XoM/GUnRWRDuB+IWKi+9oSh+T/mWDs0reMnO1AHceP/L6IdMRTdtaau0ftcRxpBz0FhBZQD376geyfQ0Re3Ik6DlO3fmP6937cbNaPPAe0G6M9BRWtplrV/Rp4PXBmLV6jvxeR9xJpe2JZTf65Kbod1e+ATWUK3EHkwEtp++aiE5fYEvoFaQOmyiCfEqTNQH8B5+OIp20FuQhcANwSyN25NXJxjsOnLwJIbo42KHoJ2BlQoFeQNxIZ+96yx1oMbSFDgpyc7+BWiocictJChopmmmKDLZlRRaQT+ArwM7wDnAXpbMmMaqDWsaDTi6rqN8AeD8g1EXkrkbZtz1zp2+BUrLFF5AQwWmR6VERORCrW2H4cvgLbBgYQY7qB9oLClAPaxZjubQMDlC0AEL894ojIOeDy/EtV4LKInIvfHnFWbKOCGj3ZFN2hc68cETmQSNt9QdZZQQXEqugnP/vJ4nfA+A/fSUn8A26hXAAAAABJRU5ErkJggg==';
      logo.style.marginRight = "5px";
      // logo.style.cursor = 'pointer';
  
      logoText.innerHTML = window.powersearchUserSettings.mapOpts.logoOpts.text; 
      // controlDiv.appendChild(logo);
      controlDiv.appendChild(logoText);
  
      // google.maps.event.addDomListener(logo, 'click', function() {
      //     window.location = 'https://www.hearby.com'; 
      // });

  }
  
}

  google.maps.event.addListener(aMap.map, 'idle', () => {
    const new_center = aMap.map.getCenter();
      if (
        getDistance(
          aMap.map.getCenter().lat(),
          aMap.map.getCenter().lng(),
          prevCenter.lat(),
          prevCenter.lng(),
          ) > aMap.distance
          ) {
          if (aMap.zoom > 8) {
          aMap.loc = {
            lat: new_center.lat(),
            lng: new_center.lng(),
          }
          aMap.setMapMarkers();
          prevCenter = new_center;
        }

      }

  });


  google.maps.event.addListener(aMap.map, 'zoom_changed', () => {
    const new_center = aMap.map.getCenter();
    if (
      getDistance(
          new_center.lat(),
          new_center.lng(),
          aMap.loc.lat,
          aMap.loc.lng,
      ) > aMap.distance
    ) {
      aMap.loc.lat = new_center.lat();
      aMap.loc.lng = new_center.lng();
    }

    const prevZoom = aMap.map.getZoom();
    if (prevZoom >= 8 && aMap.zoom < 8 && aMap.zoom != prevZoom) {
      aMap.zoom = prevZoom;
      deleteMarkers(aMap.map);
      aMap.setMapMarkers();
    }

    if (prevZoom < 8 && aMap.zoom >= 8 && aMap.zoom != prevZoom) {
      aMap.zoom = prevZoom;
      deleteMarkers(aMap.map);
      aMap.setMapMarkers();
    }
    aMap.zoom = prevZoom;
  });
}

export function initMapEl(mapId) {
    // do this in render map
    // attach to this.mapId not js map
    const mapEl = document.querySelector(mapId);
    mapEl.innerHTML = `
      <div class="hearbyMap ${mapId}">
      </div>
      `;
      
    mapEl.style.width = window.window.powersearchUserSettings.mapOpts.mapWidth;
    mapEl.style.height =  window.window.powersearchUserSettings.mapOpts.mapHeight;

    return mapEl;
}

export {renderMap};
